<template>
	<div id="buildingRightBottom1">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">逐时运行参数</span>
				</div>
			</div>
			<div>
				<div id="buildingRightLine" style="width: 100%; height: 3rem;"></div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chart: null,
				chartData: []
			};
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.homePageZll();
				},
			}
		},
		mounted() {
			this.homePageZll();
		},
		methods: {
			async homePageZll() {
				let dataObj = {
					building_id: this.building,
				}
				await this.$axios.get("/api/buildings/homePageZll", {
					params: dataObj
				}).then(res => {
					let timeData = []
					let zllData = []
					let powerData = []
					for (let item of res.data.data.time_zll_list) {
						timeData.push(item.time_stamp)
						zllData.push(item.zll)
						powerData.push(item.cooling_power)
					}
					this.chartData = [timeData, zllData, powerData]
					this.draw();
				})
			},
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("buildingRightLine")
				);

				let option = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						show: true,
						orient: 'horizontal',
						right: 10,
						top: 0,
						textStyle: {
							fontSize: 12,
							fontWeight: 'bold',
							color: '#fff'
						},
					},
					xAxis: {
						type: "category",
						data: this.chartData[0],
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#323232',
								type: "dashed"
							}
						}
					},
					yAxis: [{
							type: "value",
							name: "KW",
							nameTextStyle: {
								color: '#fff'
							},
							axisLabel: {
								formatter: function(value) {
									return value;
								},
								textStyle: {
									color: '#fff'
								}
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: '#323232',
									type: "dashed"
								}
							}
						},
						{
							type: "value",
							name: "KW",
							nameTextStyle: {
								color: '#fff'
							},
							axisLabel: {
								formatter: function(value) {
									return value;
								},
								textStyle: {
									color: '#fff'
								}
							},
							splitLine: {
								show: true,
								lineStyle: {
									color: '#323232',
									type: "dashed"
								}
							}
						}
					],
					series: [{
						type: "line",
						name: "运行制冷量",
						yAxisIndex: 0,
						data: this.chartData[1],
						itemStyle: {
							normal: {
								color: '#2A9DFF',
								borderWidth: 3,
								borderColor: '#2A9DFF'
							}
						},
						lineStyle: {
							color: '#2A9DFF'
						}
					}, {
						type: "line",
						name: "运行制冷功率",
						yAxisIndex: 1,
						data: this.chartData[2],
						itemStyle: {
							normal: {
								color: '#41E4BB',
								borderWidth: 3,
								borderColor: '#41E4BB'
							}
						},
						lineStyle: {
							color: '#41E4BB'
						}
					}, ],
				};
				this.chart.setOption(option);
			},
		},
	};
</script>

<style lang="scss">
	#buildingRightBottom1 {
		height: 3.2125rem;
		width: 7.35rem;
	}
</style>
